import type { SvgIconComponent } from "@mui/icons-material";
import { useVacationDaysFormat } from "~components/shared/useVacationDaysFormat.ts";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext.tsx";
import { useTranslation } from "~contexts/I18nContext/I18nContext";
import type { VacationEntitlement } from "~generated";
import { TimeCard } from "./TimeCard";

export type LegacyVacationEntitlementCardProps = {
  vacation: VacationEntitlement;
  icon?: SvgIconComponent;
};

export function LegacyVacationEntitlementCard({
  vacation,
  icon,
}: LegacyVacationEntitlementCardProps) {
  const t = useTranslation();
  const { currentEmployee } = useCurrentEmployee();
  const vacationDays = useVacationDaysFormat();

  const tooltip = currentEmployee.is_white_collar_worker ? (
    <div>
      <p>{t.vacationEntitlementTooltip}</p>
      <p>{t.vacationEntitlementTooltipWhiteCollarWorker}</p>
    </div>
  ) : (
    t.vacationEntitlementTooltip
  );

  const card = {
    label: t.vacationEntitlement,
    ...vacationDays.parts(vacation.entitlement_days - vacation.used_days),
    tooltip,
  };

  return icon ? (
    <TimeCard {...card} variant={{ name: "desktop", icon }} />
  ) : (
    <TimeCard {...card} />
  );
}
